import React from "react";
import {Link} from 'react-router-dom'
import '../nav.css'

function Nav(){

    return(
  <nav className="custom-navbar">
      <div className="custom-container">
        <Link className="custom-brand" to="/">Pentagon Properties</Link>

        <input type="checkbox" id="menu-toggle" className="custom-menu-toggle" />
        <label htmlFor="menu-toggle" className="custom-toggler">
          <span className="toggler-text">MENU</span>
          <i className="fas fa-bars" aria-hidden="true"></i>
        </label>

        <ul className="custom-menu">
            <li className="nav-item"><Link className="nav-link" to="/">Home</Link></li>
            <li className="nav-item"><a className="nav-link" href="#contact">Contact</a></li>
        </ul>
      </div>
    </nav>
  );
    }
    export default Nav
